export default {
    actions: {
        async authenticatedUser({ commit }, payload) {
            return commit("SET_USER", payload);
        },
        async logout({ commit }) {
            await window.axios.post("/logout").then(() => commit("SET_NULL"));
        },
    },
    getters: {
        authenticated(state) {
            return Boolean(state.user);
        },
        isAdmin(state) {
            if (state.user) {
                return state.user.role;
            }

            return false;
        },
        user(state) {
            return state.user;
        },
        roles(state) {
            if (state.roles !== null) {
                return state.roles;
            } else {
                return {};
            }
        },
    },
    mutations: {
        SET_USER(state, payload) {
            state.user = payload.autheried;
            state.roles = payload.actions;
        },
        SET_NULL(state) {
            state.user = null;
            state.roles = null;
        },
    },
    namespaced: true,
    state: {
        user: null,
        roles: null,
    },
};
